<template>
  <div class="public-content epay-trade">
    <div class="breadcrumb">税率列表</div>
    <div class="right-main">
      <!--      查询订单-->
      <el-form :inline="true" :model="formInline" label-width="100px" class="demo-form-inline">
        <el-row>
          <el-col :span="6">
            <el-form-item label="商品名称:">
              <el-input v-model="formInline.productName" clearable placeholder="请输入商品名称" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="简称:">
              <el-input v-model="formInline.shortProductName" clearable style="width: 160px;" placeholder="请输入简称" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="税收分类编码:">
              <el-input v-model="formInline.taxRateTypeCode" clearable placeholder="请输入税收分类编码" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="税收分类名称:">
              <el-select v-model="formInline.taxRateTypeName" clearable placeholder="请选择">
                <el-option v-for="item in rateTypeList" :key="item.taxRateTypeId" :label="item.rateName" :value="item.rateName">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24" class="fn-right" style="margin-top:22px;">
            <div class="fn-right">
              <el-button round @click="onSubmit(1)">查询</el-button>
              <el-button type="primary" round @click="$refs.rateType.show()">税收分类管理</el-button>
              <el-button type="primary" round @click="$refs.rateAddVue.show()">新增税收商品</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <div class="data-list">
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column label="商品名称" prop="productName"></el-table-column>
          <el-table-column label="简称" prop="shortProductName"></el-table-column>
          <el-table-column label="税收分类名称" prop="taxRateType.rateName"></el-table-column>
          <el-table-column label="税收分类编码" prop="taxRateType.rateCode"></el-table-column>
          <el-table-column label="税率" prop="taxRate">
            <template slot-scope="scope">{{ scope.row.taxRate + '%' }}</template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <span class="color-blue" v-show="!scope.row.isDefault" @click="setDefault(scope)">设为默认</span>
              <span v-show="scope.row.isDefault">默认设置</span>
              <span class="color-blue" style="margin-left:5px;" @click="confirmDelete(scope)">删除</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--    分页-->
      <v-pagination class="v-pagination" :query-info="queryInfo" @changePage="changePage" />
    </div>
    <!-- 删除 -->
    <el-dialog :close-on-click-modal="false" append-to-body title="删除确认" :visible.sync="deleteDialog" width="400px">
      <span>确认删除该税率吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button round @click="deleteDialog = false">取 消</el-button>
        <el-button round type="primary" @click="deleteRate()">确 定</el-button>
      </span>
    </el-dialog>
    <rateType ref="rateType"></rateType>
    <rateAddVue ref="rateAddVue" @success="onSubmit"></rateAddVue>
  </div>
</template>
 <script>
import VPagination from '@/components/Pagination/index.vue'
import rateType from './rateType.vue'
import rateAddVue from './rateAdd.vue'
import { taxRatePage, taxRateDelete, taxRateSetDefaultTaxRate, taxRateTypeListAll } from '@/api/finance'
export default {
  components: {
    VPagination, rateType, rateAddVue
  },
  data () {
    return {
      deleteDialog: false,
      formInline: {
        dateEnd: '',
        dateStart: '',
        outOrderNo: '',
        salesmanId: '',
        storeId: '',
        tradeMethod: '',
        tradeNo: '',
        tradeType: ''
      },
      tableData: [],
      queryInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      rateTypeList: []
    }
  },
  created () {
    this.getAllRateList()
    this.onSubmit()
  },
  methods: {
    getAllRateList () {
      taxRateTypeListAll()
        .then(res => {
          if (res.data.success) {
            this.rateTypeList = res.data.data
          }
        })
    },
    setDefault (scope) {
      taxRateSetDefaultTaxRate(scope.row.taxRateId)
        .then(res => {
          if (res.data.success) {
            this.$message.success('设置成功')
            this.onSubmit()
          }
        })
    },
    confirmDelete (scope) {
      this.deleteId = scope.row.taxRateId
      this.deleteDialog = true
    },
    async deleteRate () {
      await taxRateDelete(this.deleteId)
        .then(async res => {
          if (res.data.success) {
            this.$message.success('删除成功')
            this.deleteDialog = false
            await this.onSubmit()
            if (this.tableData.length === 1) {
              this.onSubmit(this.queryInfo.pageNum - 1)
            }
          }
        })
    },
    onSubmit (num) {
      this.queryInfo.pageNum = num || this.queryInfo.pageNum
      taxRatePage({
        data: this.formInline,
        params: {
          page: this.queryInfo.pageNum - 1,
          size: this.queryInfo.pageSize
        }
      })
        .then(res => {
          if (res.data.success) {
            this.tableData = res.data.data.content
            this.queryInfo.total = res.data.data.total
          }
        })
    },
    changePage (val) {
      this.queryInfo = val
      this.onSubmit()
    }
  }
}
</script>
 <style scoped lang="less">
 // @import "index";
 @deep: ~">>>";
 </style>
